<script>
  import { mapState, mapActions } from 'vuex'
  import { TopBar, LoadingOverlay } from '@/components/_shared'
  import { ChannelsSubscription, ChannelsList } from '@/components/channels'

  export default {
    name: 'channels-list-view',

    components: {
      TopBar,
      LoadingOverlay,
      ChannelsSubscription,
      ChannelsList
    },

    metaInfo: {
      title: 'Channels'
    },

    computed: {
      ...mapState('channels', {
        channels: state => state.channels,
        loading: state => state.loading
      })
    },

    methods: {
      ...mapActions('channels', [
        'loadChannels',
        'clearChannels'
      ]),

      ...mapActions('app', [
        'showModal'
      ])
    },

    created () {
      this.loadChannels()
    },

    destroyed () {
      this.clearChannels()
    }
  }
</script>

<template>
  <div>
    <top-bar title="Channels" icon="play">
      <template slot="actions">
        <b-button variant="primary" @click="showModal('ChannelNewModal')">New Channel</b-button>
      </template>
    </top-bar>
    <b-container fluid>
      <loading-overlay :is-loading="loading">
        <channels-subscription/>
        <channels-list :channels="channels"/>
      </loading-overlay>
    </b-container>
  </div>
</template>
